import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);



import './assets/css/common.scss'
import 'babel-polyfill' //兼容性
Vue.config.productionTip = false


import {getList,getColumn} from '@/api/list'
Vue.prototype.getList=getList
Vue.prototype.getColumn=getColumn





import {getPortalToken} from '@/api/base'

getPortalToken().then(_=>{
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
  
})
